import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SUB_COMPANY_LOAN_COUNT_ACTION_TYPE } from '../actions';

const initialState = null;

const subCompanyLoanCountReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case SUB_COMPANY_LOAN_COUNT_ACTION_TYPE.GET_LOAN_COUNT:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default subCompanyLoanCountReducer;
